/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Header_navigation = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_navigation",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BottomBar_navigation",
      "args": null
    }
  ],
  "type": "Navigation"
};

module.exports = fragment;
